import { useMarketIndexes } from '../../store/market/hooks'
import { Ether, TokenSymbol } from '../../types'
import { getMarkPriceFromIndexes } from '../../utils/getMarkPriceFromIndexes'

export function useCurrencyMarkPrice(baseCurrency: TokenSymbol): Ether {
  const indexes = useMarketIndexes()
  return getMarkPriceFromIndexes(indexes, baseCurrency)
}
